<template>
  <div
    class="users-list"
    v-if="!isLoading"
  >
    <InputSearch v-model="searchInput" />
    <div
      class="users-list__users"
      v-if="results.length"
    >
      <table>
        <thead>
          <tr>
            <th>
              Ações
            </th>
            <th>
              Nome
            </th>
            <th>
              Email / Usuário
            </th>
            <th>
              Acesso(s)
            </th>
            <th>
              Ativo?
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in results"
            :key="index"
          >
            <td>
              <a @click="$emit('selected', item)" >🖋</a>
              <a @click="$emit('password', item)" class="mx-4">🔐</a>
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>
              {{ item.roles.join(',') }}
            </td>
            <td>
              <strong>{{ item.active ? 'Sim' : 'Não' }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <EmptyState
      v-else
      :query="searchInput"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'ListUsers',

  inject: ['searchItems'],

  data () {
    return {
      users: [],
      searchInput: '',
      columns: [
        {
          classes: 'w-16 justify-end pr-2',
          name: 'role'
        },
        {
          name: 'email'
        }
      ],
      sort: {
        column: 'name',
        direction: -1
      },
      results: []
    }
  },

  computed: {
    ...mapState('auth', ['userProfile']),
    ...mapState('global', ['isLoading'])
  },

  watch: {
    searchInput (next) {
      if (next.length > 2 || next.length === 0) {
        this.searchResult()
      }
    }
  },

  methods: {
    ...mapMutations('global', ['SET_IS_LOADING']),

    setItems (data) {
      this.users = data
    },

    fetchData () {
      const url = process.env.VUE_APP_NEW_API + '/user'

      this.SET_IS_LOADING(true)

      axios
        .get(url, { headers: { Authorization: 'Bearer ' + this.userProfile.token } })
        .then((response) => {
          this.setItems(response.data.data)
          this.searchResult()
        })
        .catch((error) => {
          throw error
        })
        .then(() => {
          this.SET_IS_LOADING(false)
        })
    },

    searchResult () {
      this.results = []
      const query = this.searchInput.toLowerCase().trim()
      const items = this.users
      let result = this.searchItems(items, query) || []
      if (this.sort.column) {
        result = result.sort((a, b) => {
          const first = this.sort.direction < 0 ? a : b
          const second = this.sort.direction < 0 ? b : a
          if (this.sort.column !== 'id') {
            return first[this.sort.column]
              .toLowerCase()
              .trim()
              .localeCompare(second[this.sort.column].trim().toLowerCase())
          } else {
            return first.id - second.id
          }
        })
      }

      this.isSorting = false
      this.results = result
    }
  },

  mounted () {
    this.fetchData()
  }
}
</script>

<style lang='scss' scoped>
table {
  @apply w-full;
  thead {
    @apply font-bold text-primary;
    @apply border-b border-gray-300 border-solid;
  }
  td, th {
    @apply px-2 py-2 text-left;
  }
  tbody {
    tr {
      @apply text-primary;
      &:nth-child(even) {
        @apply bg-gray-100;
      }
      &:hover {
        @apply bg-primary text-white;
      }
    }
  }
}
</style>
